import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-country-flag',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './country-flag.component.html',
  styleUrl: './country-flag.component.scss'
})
export class CountryFlagComponent {

  @Input() name: string = '';
  @Input() countryCode: string = '';
  @Input() size: number = 24;
  @Input() rounded: boolean = false;

  public imageError = false;

  get dimensions(): { [key: string]: string } {
    return {
      width: `${this.size}px`,
      height: `${this.size}px`
    };
  }

  get flagImage(): string | null {
    if (!this.countryCode || this.imageError) {
      return null;
    }

    return `assets/icons/country-flag/${this.countryCode.substring(0, 2).toUpperCase()}.svg`;
  }

  onImageError(): void {
    this.imageError = true;
  }
}